import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { decimal, percent, validUUID, validString, date, dateRange } from "Components/shared/helpers/validations";

const surcharge = Yup.object().shape({
    fixedAmount: Yup.mixed().when("percentage", {
        is: "",
        then: decimal.required(),
        otherwise: Yup.lazy((value) => {
            return value ? decimal : Yup.mixed().optional();
        }),
    }),
    percentage: Yup.mixed().when("fixedAmount", {
        is: "",
        then: percent.required(),
        otherwise: Yup.lazy((value) => {
            return value ? percent : Yup.mixed().optional();
        }),
    }),
    capAmount: Yup.mixed().when("percentage", {
        is: "percentage",
        then: decimal.required()
    }),
}, [["fixedAmount", "percentage"]]); // here is where you tell it which of these are dependent on each other

const surchargeType = validString.oneOf(['DEFAULT', 'DISCOUNT', 'MARKUP']);

export const AddCustomersSchema = Yup.object().shape(
    reverseShape({
        orderSettingID: validUUID.optional(),
        surchargeType: surchargeType.required(),
        surcharge: surcharge,
        validFrom: date.required(),
        validTo: date.required().concat(dateRange),
    })
);
